import React, { useState } from 'react';
import { Circle, Marker } from '@react-google-maps/api';
import AlcoholZoneInfoWindow from '../infoWindows/AlcoholZoneInfoWindow';

const YARDS_TO_METRES = 0.9144;

const AlcoholZoneLayer = ({ churches = [], schools = [] }) => {
  const [selected, setSelected] = useState(null);

  const renderZones = (places, type) => {
    const isSchool = type === 'school';
    const bufferYards = isSchool ? 200 : 100;
    const bufferMetres = bufferYards * YARDS_TO_METRES;
    const fillColor = isSchool ? '#dc2626' : '#f97316';
    const icon = isSchool ? '🏫' : '⛪';

    return places.map((place, idx) => {
      const lat = Number(place.latitude);
      const lng = Number(place.longitude);
      if (isNaN(lat) || isNaN(lng)) return null;

      const position = { lat, lng };

      return (
        <React.Fragment key={`${type}-${place.place_id || idx}`}>
          {/* Buffer zone circle */}
          <Circle
            center={position}
            radius={bufferMetres}
            options={{
              fillColor,
              fillOpacity: 0.15,
              strokeColor: fillColor,
              strokeOpacity: 0.6,
              strokeWeight: 2,
              strokeDashArray: '5 5',
              clickable: true,
              zIndex: 1,
            }}
            onClick={() => setSelected({ place, placeType: type, position })}
          />
          {/* Marker in the centre */}
          <Marker
            position={position}
            onClick={() => setSelected({ place, placeType: type, position })}
            label={{ text: icon, fontSize: '16px' }}
            icon={{
              path: window.google?.maps?.SymbolPath?.CIRCLE || 0,
              scale: 8,
              fillColor: fillColor,
              fillOpacity: 0.9,
              strokeColor: '#fff',
              strokeWeight: 2,
            }}
            title={place.name}
          />
        </React.Fragment>
      );
    });
  };

  return (
    <>
      {renderZones(churches, 'church')}
      {renderZones(schools, 'school')}

      {selected && (
        <AlcoholZoneInfoWindow
          place={selected.place}
          placeType={selected.placeType}
          position={selected.position}
          onClose={() => setSelected(null)}
        />
      )}
    </>
  );
};

export default AlcoholZoneLayer;
